import { ProductV2 } from '@common'

export const isStoreSpecial = (product: ProductV2) => {
  return product.type === 'offer' && product.tags?.includes('store:special')
}

export const isSeasonPass = (product: ProductV2) => {
  return !!product.contentCounts.SEASON_PASS
}

export const isNormalOffer = (product: ProductV2) => {
  return product.type === 'offer' && !isSeasonPass(product) && !isStoreSpecial(product)
}
